<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">EMPREENDEDORISMO DIGITAL</h1>
      <div class="title-main">
        <p>Empreendedorismo é a disposição ou capacidade de idealizar, coordenar e realizar projetos, serviços e/ou negócios. Para concluir o diagnóstico, vamos entender como está sua percepção sobre empreender em um cenário que envolve o digital.<p>
        <p>As questões a seguir abordam sobre disrupção, transformação cultural, produtividade e crescimento exponencial.</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'empreendedorismo_digital',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/empreendedorismo-digital/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 6);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/DigitalEntrepreneurship.vue